<script>
  import { fade } from "svelte/transition";

  /**@type {string | ??}*/
  export let source;
  /**@type {boolean}*/
  export let isCoverImage = false;
  /**@type {string | ??}*/
  export let borderRadius = 0;
  /**@type {string}*/
  export let alt = "";
  /**@type {boolean}*/
  export let isProduct = false;
  /**@type {string}*/
  export let width;

</script>

<div
  class="container-pictures"
  class:productImage={isProduct}
>
  <picture>
    <source type="image/webp" srcset={`${source}-${width}px@2x.webp`} media="(min-width: 520px)" />
    <source type="image/webp" srcset={`${source}-${width}px.webp 1x`} />
    <img loading="lazy" src={`${source}-60px.webp`} class={isCoverImage ? " cover" : "contain"} style={`border-radius: ${borderRadius}px`} {alt}  transition:fade />
  </picture>
</div>

<style>
  .container-pictures {
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  .productImage {
    max-height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
    object-fit: contain;
  }

  picture {
    display: contents;
  }
  .contain {
    width: 100%;
    max-height: 500px;
    object-fit: contain;
    object-position: center;
    border-radius: 10px;
    height: 100%;
  }
  .cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0;
    object-position: center;
  }
  .productImage img {
    height: fit-content;
    object-fit: contain !important;
    object-position: center;
    max-height: 240px;
    width: 100%;
    pointer-events: none;
  }
</style>
